import { motion } from "motion/react";
import React, { PropsWithChildren } from "react";

import { cn } from "../../../../../lib/utils";

export const PopIn = ({
	children,
	dangerouslySetClassName,
}: PropsWithChildren<{ dangerouslySetClassName?: string }>) => {
	return (
		<motion.div
			initial={{ scale: 0 }}
			animate={{ scale: 1 }}
			exit={{ scale: 0 }}
			transition={{
				type: "spring",
				stiffness: 500,
				damping: 25,
			}}
			className={cn(dangerouslySetClassName)}
		>
			{children}
		</motion.div>
	);
};
